import { DateTime } from "luxon";
// import { config } from "../config";
import { Contact } from "../types/Contact";
import { getAvailableTimeSlotsResponseValue, getClientResponseValue, AvailableTimeSlot, Opportunity, getOpportunityResponse, getCodeResponseValue, ScheduleResponse } from "../types/DynamicsService";
import { CheckoutSession } from "../types/Stripe";


export const dynamicsService = {
  getAvailableTimeSlots,
  createOrUpdateClient,
  createOrUpdatePrimaryContact,
  createCheckoutSession,
  getOpportunityStatus,
  getClient,
  getCodeDiscount,
  scheduleOpportunity,
};

export function fetchResponseToJson(response: any) {

  function logout() {
    localStorage.removeItem("token");
  }
  return response.text().then((text: string) => {
    //const data = text && JSON.parse(text, parseWithDate);
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function createOrUpdateClient(checkoutId: string, contact : Contact): Promise<string> {

  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      checkoutId,
      city: contact.city, 
      email: contact.email, 
      dob: contact.dob,
      firstName: contact.firstName,
      lastName: contact.lastName, 
      state: contact.state, 
      streetAddress: contact.address1, 
      streetAddress2: contact.address2,
      telephone: contact.telephone, 
      zip: contact.zipcode
    }),
  };
  return fetch(window.orderAssessmentConfig.createOrUpdateClientUrl, requestOptions).then(
    fetchResponseToJson
  ).then((response: getClientResponseValue) => {
    console.log("createOrUpdateClient", response);
    // if (response.territories === 0) {
    //   window.location.href = '/coming-soon';
    //   return "";
    // }
    return response.forza_clientid;
  });
}

function createOrUpdatePrimaryContact(contact : Contact, clientId: string): Promise<string> {

  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      city: contact.city, 
      email: contact.email, 
      firstName: contact.firstName,
      lastName: contact.lastName, 
      state: contact.state, 
      streetAddress: contact.address1, 
      streetAddress2: contact.address2,
      telephone: contact.telephone, 
      zip: contact.zipcode,
      dob: contact.dob,
      clientId: clientId, 
    }),
  };
  return fetch(window.orderAssessmentConfig.createOrUpdatePrimaryContactUrl, requestOptions).then(
    fetchResponseToJson
  ).then((response: getClientResponseValue) => {
    console.log(requestOptions);
    console.log(response);
    return response.forza_primarycontactid;
  });
}


function getAvailableTimeSlots(date: DateTime): Promise<AvailableTimeSlot[]> {

  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      startDate: date.toISO(),
      endDate: date.plus({ days: 1 }).toISO()
    }),
  };
  return fetch(window.orderAssessmentConfig.timeSlotUrl, requestOptions).then(
    fetchResponseToJson
  ).then((response: getAvailableTimeSlotsResponseValue[]) => {
    // SELET forza_availabletimeslots(forza_availableassessors,forza_date,forza_timeslot)
    return response
      //.filter((value) => value.forza_availableassessors > 0)
      .map((value) => {
        let timeSlotHours = 0;
        let timeSlotMinutes = 0;
        // forza_timeslot@OData.Community.Display.V1.FormattedValue
        switch (value.forza_timeslot) {
          case 876960000: //9am eastern
            timeSlotHours = 9;
            //timeSlot = "8:00am - 11:00am";
            break;
          case 876960001: //10:30am eastern
            // timeSlot = "11:00am - 2:00pm";
            timeSlotHours = 10;
            timeSlotMinutes = 30;
            break;
          case 876960002: // 1pm eastern
            timeSlotHours = 13;
            // timeSlot = "2:00pm - 5:00pm";
            break;
          case 876960003: //2:30pm eastern
            timeSlotHours = 14;
            timeSlotMinutes = 30;
            // timeSlot = "5:00pm - 8:00pm";
            break;
        }
        //let timeSlotString = moment(value.forza_date).tz("America/New_York").hours(timeSlotHours).format("HH:mm a");
        const timeSlotString = DateTime.fromISO(value.forza_date).setZone("America/New_York").set({ hour: timeSlotHours, minute: timeSlotMinutes }).toLocal().toFormat("h:mm a");
        return {
          id: value.forza_availabletimeslotid, // GUID
          //forza_date@OData.Community.Display.V1.FormattedValue
          date: value.forza_date, // UTC, e.g. "2020-12-20T17:13:05Z"
          timeSlot: timeSlotString,
          assessorsAvailable: value.forza_availableassessors,
        };
      });
  });
}

function createCheckoutSession(stripePrice: string, stripeMode: string, baseUrl: string, code: string | undefined): Promise<CheckoutSession> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      base_url: baseUrl,
      code: code,
      stripePrice,
      stripeMode
    }),
  };
  return fetch(window.orderAssessmentConfig.checkoutUrl, requestOptions).then(
    fetchResponseToJson
  );

}

function getOpportunityStatus(id: string): Promise<getOpportunityResponse> {

  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      opportunityId: id
    }),
  };
  return fetch(window.orderAssessmentConfig.opportunityStatusUrl, requestOptions).then(
    fetchResponseToJson
  );
}


function getClient(contact: string): Promise<Contact | undefined> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      contact,
    }),
  };
  return fetch(window.orderAssessmentConfig.getClientUrl, requestOptions).then(
    fetchResponseToJson
  ).then((response: getClientResponseValue) => {
    console.log(response);
    if (response.territories === 0) {
      window.location.href = '/coming-soon';
      return undefined;
    }
    return response.contact;
  });
}


function getCodeDiscount(code: string): Promise<getCodeResponseValue> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      code,
    }),
  };
  return fetch(window.orderAssessmentConfig.getCodeUrl, requestOptions).then(
    fetchResponseToJson
  );
}


function scheduleOpportunity(checkoutId: string, clientId: string, primaryContactId: string, timeSlot: string): Promise<ScheduleResponse> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      checkoutId,
      clientId,
      primaryContactId,
      timeSlot,
    }),
  };
  return fetch(window.orderAssessmentConfig.scheduleUrl, requestOptions).then(
    fetchResponseToJson
  );

}